export default {
  state: {
    measures: [],
    loading: false,
  },
  getters: {
    measures: state => state.measures,
    loading: state => state.loading,
  },
  mutations: {
    setMeasures(state, measures) {
      state.measures = measures;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const measures = await axios.get('api/declutter-measures');
        commit('setMeasures', measures);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/declutter-measures/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
      await axios.post('api/declutter-measures', payLoad);
    },

    async update({ commit }, payLoad) {
      await axios.put('api/declutter-measures', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/declutter-measures/' + id);
    }
  },
};
